module.exports = __webpack_public_path__ + "files/1725f34ac136608d999a9d059f0d14e5.png";